"use strict";

export function getElement<T extends Element>(selector: string, scope: ParentNode | Document): T;
export function getElement<T extends Element>(selector: string, scope: ParentNode | Document, isElementArray: true): T[];
export function getElement<T extends Element>(selector: string, scope: ParentNode | Document, isElementArray: false): T;
export function getElement<T extends Element>(selector: string, scope: ParentNode | Document, isElementArray?: boolean): T | T[] {
  try {
    if (isElementArray) {
      const element = [...scope.querySelectorAll(selector)] as T[];
      if (element.length < 1) return null as unknown as T[];
      return element;
    } else {
      const element = scope.querySelector(selector) as T;
      if (!element) return null as unknown as T;
      return element;
    }
  } catch (e) {
    throw new Error(`There is an error. Please check if your selector: ${selector} is correct`);
  }
}

export function addDomEvent(el: string, event: string, func: EventListenerOrEventListenerObject): void;
export function addDomEvent(el: string, event: string, func: EventListenerOrEventListenerObject, multipleElements: true): void;
export function addDomEvent(el: string, events: string[], func: EventListenerOrEventListenerObject): void;
export function addDomEvent(el: string, events: string[], func: EventListenerOrEventListenerObject, multipleElements: true): void;
export function addDomEvent<T extends Element>(el: string, eventOrEvents: string | string[], func: EventListenerOrEventListenerObject, multipleElements?: boolean): void {
  const events = Array.isArray(eventOrEvents) ? eventOrEvents : [eventOrEvents];

  try {
    if (multipleElements) {
      const elements = getElement<T>(el, document, true) as T[];
      elements.forEach((element) => events.forEach((event) => element.addEventListener(event, func, true)));
    } else {
      const element = getElement<T>(el, document, false) as T;
      events.forEach((event) => element.addEventListener(event, func, true));
    }
  } catch (e) {
    throw new Error(`There is an error. Please check if your selector: ${el} is correct`);
  }
}
